import { SidebarFooterDismissButton } from '@/components/blocks/Layout/Sidebar/SidebarFooterRow';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { trackEvent } from '@/utils/analytics';

import { changelogSeenStore } from './changelog-seen.store';
import { type ChangelogEntry } from './changelog.feed';

export const ChangelogDismissMenu = ({ entry }: { entry: ChangelogEntry }) => (
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild>
      <SidebarFooterDismissButton aria-label="Dismiss what's new" />
    </DropdownMenu.Trigger>
    <DropdownMenu.Content align="end" fit>
      <DropdownMenu.Item
        onClick={() => {
          trackEvent('CHANGELOG_SIDEBAR_DISMISSED', { choice: 'keep_showing' });
          changelogSeenStore.keepShowing(entry.id);
        }}
      >
        Keep showing
      </DropdownMenu.Item>
      <DropdownMenu.Item
        onClick={() => {
          trackEvent('CHANGELOG_SIDEBAR_DISMISSED', { choice: 'stop_showing' });
          changelogSeenStore.stopShowing(entry.id);
        }}
      >
        Stop showing
      </DropdownMenu.Item>
    </DropdownMenu.Content>
  </DropdownMenu.Root>
);
